import { createReducer, on } from '@ngrx/store';
import { CrewLogResult } from '../../features/attendance-log/models';
import { AttendanceLogActions } from './attendance-log.actions';

export interface AttendanceLogState {
  /** The last loaded crew log page; kept while the next one loads so the table does not blink. */
  crewLog: CrewLogResult | null;
  loading: boolean;
  /** True when the last crew log request failed. */
  loadFailed: boolean;
  exporting: boolean;
}

export const initialAttendanceLogState: AttendanceLogState = {
  crewLog: null,
  loading: false,
  loadFailed: false,
  exporting: false,
};

export const attendanceLogReducer = createReducer(
  initialAttendanceLogState,
  on(AttendanceLogActions.loadCrewLog, (state, { query }) => ({
    ...state,
    // A different crew member must not briefly show the previous person's log.
    crewLog: state.crewLog?.header.crewId === query.crewId ? state.crewLog : null,
    loading: true,
    loadFailed: false,
  })),
  on(AttendanceLogActions.loadCrewLogSuccess, (state, { result }) => ({
    ...state,
    // A filtered page can come back without rows; the crew member's rotation is the same throughout, so keep it.
    crewLog: {
      ...result,
      header: {
        ...result.header,
        rotation:
          result.header.rotation ??
          (state.crewLog?.header.crewId === result.header.crewId
            ? (state.crewLog.header.rotation ?? null)
            : null),
      },
    },
    loading: false,
  })),
  on(AttendanceLogActions.loadCrewLogFailure, (state) => ({
    ...state,
    loading: false,
    loadFailed: true,
  })),
  on(AttendanceLogActions.exportCrewLog, (state) => ({ ...state, exporting: true })),
  on(
    AttendanceLogActions.exportCrewLogSuccess,
    AttendanceLogActions.exportCrewLogFailure,
    (state) => ({
      ...state,
      exporting: false,
    })
  )
);
